import React from "react";
import { useNavigate } from "react-router-dom";
import Form from "../../componets/Form";

export default function Section13() {
  const navigate = useNavigate();

  return (
    <div className="w-full Section13">
      <div className="container-1280 section13-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%] text-center pt-[35px] pb-[20px]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] my-[0.67em] text-[#151515]">
          Ready to Build Your Mobile App?
        </h2>

        <p className="w-full md:w-[70%] mx-auto leading-[22px] text-[#535353] text-sm md:text-base font-open mb-3">
          Your customers are already using mobile devices every day. A
          well-designed app can help your business create better experiences
          and grow faster.
        </p>
        <p className="w-full md:w-[70%] mx-auto leading-[22px] text-[#535353] text-sm md:text-base font-open mb-8">
          Talk to Mean3 today and start planning your custom mobile
          application.
        </p>

        <button
          onClick={() => navigate("/contact-mean3")}
          className="inline-block py-[12px] px-[30px] bg-[#cd2122] rounded-[3px] font-bold text-white border-none leading-[1.15] hover:bg-[#a81a1b] transition-colors"
        >
          Get Your Free Quote
        </button>
      </div>

      {/* <Form /> */}
    </div>
  );
}
